import Swiper from "../components/Swiper/Swiper.js"
import GuaranteeSearchFull from "../components/GuaranteeSearch/GuaranteeSearchFull.js"
import CorporateProfile from "../components/IndexPage/CorporateProfile.js"
import IndexTab from "../components/IndexPage/IndexTab.js"
import CompanyDynamics from "../components/IndexPage/CompanyDynamics.js"
import Industry from "../components/IndexPage/Industry.js"
import Partnership from "../components/IndexPage/Partnership.js"


export default function Index() {
  //const { id } = useParams();
  return (
    <>
      <div style={contentStyle}>
        <Swiper />
        <div >
          <GuaranteeSearchFull />
          <CorporateProfile />
          <IndexTab />
          <CompanyDynamics />
          <div className={"div100"}></div>
          <Industry />
          <Partnership />
        </div>
      </div>
    </>
  );
}

const contentStyle = {
  //position: "relative", top: "-65px", zIndex: "-1", marginBottom: "-65px"
};